import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,numericSortFunc,dateSortFunc } from "common/SharedFn";
import { getAllCoupons,deleteCoupon,addCoupon,updateCoupon,getAllDiscountType } from "../../network/ApiAxios";
import {  Delete, Edit } from "@material-ui/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CouponsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [couponType, setCouponType] = useState(1);
  const [couponCode, setCouponCode] = useState("");
  const [couponValue, setCouponValue] = useState(0);
  const [startDatetime, setStartDatetime] = useState();
  const [endDatetime, setEndDatetime] = useState();
  const [minimumOrder, setMinimumOrder] = useState(0);
  const [overrideMinimumOrder, setOverrideMinimumOrder] = useState(0);
  const [maxDiscountValue, setMaxDiscountValue] = useState(0);
  const [maxUtilization, setMaxUtilization] = useState(null);
  const [maxUtilizationPerUser, setMaxUtilizationPerUser] = useState(null);
  const [restrictedToUserIds, setRestrictedToUserIds] = useState(null);
  const [restrictedToRoad, setRestrictedToRoad] = useState("");
  const [restrictedToBuilding, setRestrictedToBuilding] = useState("");
  const [restrictedToBlock, setRestrictedToBlock] = useState("");
  const [isFirstOrderOnly, setIsFirstOrderOnly] = useState(0);
  const [subscribedUsersOnly, setSubscribedUsersOnly] = useState(0);
  const [serviceApplicable, setServiceApplicable] = useState(0);
  const [applicableForRenewal, setApplicableForRenewal] = useState(0);
  const [isProOnly, setIsProOnly] = useState(0);
  const [id, setId] = useState();
  const [todaysDate, setTodaysDate] = useState(new Date());
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [externalService, setExternalService] = useState(0);
  const [discountId, setDiscountId] = useState(0);
  const [discountIds, setDiscountIds] = useState([]);
  const [discountType, setDiscountType] = useState([]);
  let history = useHistory();
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessDiscountTypesPage = () => {
    let history = createHistory();
    history.push("/admin/coupons/discount-types");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const setCurrentRecord = (info) => {
    const { id, couponType,couponCode,couponValue,startDatetime,endDatetime,minimumOrder,isFirstOrderOnly,subscribedUsersOnly,maxUtilization,maxUtilizationPerUser,restrictedToUserIds,restrictedToBuilding,restrictedToRoad,restrictedToBlock,serviceApplicable,applicableForRenewal,isProOnly,maxDiscountValue,overrideMinimumOrder,discountId,externalService } = info;
    setCouponType(couponType);
    setCouponCode(couponCode);
    setCouponValue(couponValue);
    setStartDatetime(new Date(startDatetime));
    setEndDatetime(new Date(endDatetime));
    setMinimumOrder(minimumOrder);
    setMaxDiscountValue(maxDiscountValue);
    setIsFirstOrderOnly(isFirstOrderOnly);
    setSubscribedUsersOnly(subscribedUsersOnly);
    setMaxUtilization(maxUtilization);
    setMaxUtilizationPerUser(maxUtilizationPerUser);
    setRestrictedToUserIds(restrictedToUserIds);
    setRestrictedToBuilding(restrictedToBuilding);
    setRestrictedToRoad(restrictedToRoad);
    setRestrictedToBlock(restrictedToBlock);
    setServiceApplicable(serviceApplicable);
    setApplicableForRenewal(applicableForRenewal);
    setIsProOnly(isProOnly);
    setOverrideMinimumOrder(overrideMinimumOrder);
    setDiscountId(discountId);
    setExternalService(externalService);
    setId(id);
  };

  const clearCurrentRecord = () => {

  setCouponType(1);
  setCouponCode("");
  setCouponValue(0);
  setStartDatetime();
  setEndDatetime();
  setMinimumOrder(0);
  setMaxDiscountValue(0);
  setIsFirstOrderOnly(0);
  setSubscribedUsersOnly(0);
  setDiscountId(0);
  setServiceApplicable(0)
  setMaxUtilization();
  setMaxUtilizationPerUser();
  setRestrictedToUserIds();
  setApplicableForRenewal(0);
  setIsProOnly(0);
  setOverrideMinimumOrder(0);
  setRestrictedToBuilding("");
  setRestrictedToRoad("");
  setRestrictedToBlock("");
  setExternalService(0);
    setId();
  };

  const fetchCoupons = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllCoupons();
    const { data } = response;
    const responseDiscount = await getAllDiscountType();
    if (data.result.isSuccess) {
      setDiscountType(responseDiscount.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      console.log(ex);
      showErrorNotification("Failed to fetch coupons");
    }
    setIsLoading(false);
  };



  const addCouponAction = async () => {
    setIsLoading(true);
    try{
    const response = await addCoupon(couponType,couponCode,couponValue,startDatetime,endDatetime,minimumOrder,isFirstOrderOnly,subscribedUsersOnly,maxUtilization,maxUtilizationPerUser,restrictedToUserIds,restrictedToBuilding,restrictedToRoad,restrictedToBlock,serviceApplicable,applicableForRenewal,isProOnly,maxDiscountValue,overrideMinimumOrder,discountId,externalService);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Coupon Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add coupon");
      setIsLoading(false);
    }
  };


  const updateCouponAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateCoupon(id,couponType,couponCode,couponValue,startDatetime,endDatetime,minimumOrder,isFirstOrderOnly,subscribedUsersOnly,maxUtilization,maxUtilizationPerUser,restrictedToUserIds,restrictedToBuilding,restrictedToRoad,restrictedToBlock,serviceApplicable,applicableForRenewal,isProOnly,maxDiscountValue,overrideMinimumOrder,discountId,externalService);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Coupon Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update coupon");
      setIsLoading(false);
    }
  };


  const deleteParam = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try{
    const response = await deleteCoupon(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Coupon Deleted Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to delete coupon");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if(executeUpdate){
        updateCouponAction();
    }
    else if(executeDelete){
      deleteParam();
    }
    else{
      fetchCoupons();
    }
  }, [executeUpdate,forceRefresh,executeDelete]);

  const makeTableRow = (info) => {
    if(info.couponType == 0){
      info.couponTypeText = "Fixed";
    }
    else{
      info.couponTypeText = "Percentage";
    }
    if(info.isFirstOrderOnly === 0){
      info.isFirstOrderOnlyText = "No";
    }
    else{
      info.isFirstOrderOnlyText = "Yes";
    }
    if(info.subscribedUsersOnly === 0){
      info.subscribedUsersOnlyText = "No";
    }
    else{
      info.subscribedUsersOnlyText = "Yes";
    }
    if(info.overrideMinimumOrder === 0){
      info.overrideMinimumOrderText = "No";
    }
    else{
      info.overrideMinimumOrderText = "Yes";
    }

    info.discountId = info?.discountType?.id;
    info.discountTypeText = info?.discountType?.name;

    switch(info.isProOnly){
      case -1:
        info.isProOnlyText = "Not Pro";
        break;
      case 0:
        info.isProOnlyText = "All Users";
        break;
      case 1:
        info.isProOnlyText = "Pro Only";
        break;
    }

    switch(info.externalService){
      case 0:
        info.externalServiceText = "None";
        break;
      case 1:
        info.externalServiceText = "Unipal";
        break;
    }

    info.startDatetimeText = dateFormat(
      new Date(info.startDatetime),
      "d-mmm-yyyy hh:MM TT"
    );

    info.endDatetimeText = dateFormat(
      new Date(info.endDatetime),
      "d-mmm-yyyy hh:MM TT"
    );

    info.createdOnText = dateFormat(
      new Date(info.createdOn),
      "d-mmm-yyyy hh:MM TT"
    );
    // if(info.userByRestrictedToUserIds != null){
    //   info.restrictedUsername = info.userByRestrictedToUserIds.firstName+" "+info.userByRestrictedToUserIds.lastName;
    // }
    // else{
    //   info.restrictedUsername = "";
    // }
    switch(info.serviceApplicable){
      case 0:
        info.serviceApplicableText = "Orders";
        break;
        case 1:
          info.serviceApplicableText = "Subscriptions";
          break;
          case 2:
            info.serviceApplicableText = "Any";
            break;
    }
    if(info.applicableForRenewal === 1){
      info.applicableForRenewalText = "Yes"
    }
    else{
      info.applicableForRenewalText = "No"
    }

    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Delete">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedError,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Delete Coupon","Are you sure you would like to delete the coupoon with id "+info.id+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })}}
                >
                  <Box component={Delete} />
                </Button>
              </Tooltip>
              </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "couponCode",
                    text: "Code",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "couponTypeText",
                    text: "Type",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "couponValue",
                    text: "Value",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "minimumOrder",
                    text: "Min. Order",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "maxDiscountValue",
                    text: "Max Value Per Order",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "maxUtilization",
                    text: "Max Util.",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "maxUtilizationPerUser",
                    text: "Max Util. Per User",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "startDatetimeText",
                    text: "Start Datetime",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "endDatetimeText",
                    text: "End Datetime",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "serviceApplicableText",
                    text: "Service Applicable",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "overrideMinimumOrderText",
                    text: "Override Minimum Order",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "applicableForRenewalText",
                    text: "Applicable for Renewal",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isFirstOrderOnlyText",
                    text: "First Order Only",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "subscribedUsersOnlyText",
                    text: "Subscribers Only",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isProOnlyText",
                    text: "Pro Status",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "restrictedToUserIds",
                    text: "Restricted To Users",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    
                    dataField: "restrictedToBuilding",
                    text: "Building",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    
                    dataField: "restrictedToRoad",
                    text: "Roads",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },

                  {
                    
                    dataField: "restrictedToBlock",
                    text: "Blocks",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },

                  
                  {
                    dataField: "createdOnText",
                    text: "Created On",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "discountTypeText",
                    text: "Discount Type",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "externalServiceText",
                    text: "External Validation",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    classes: "actions-col",
                    headerClasses: "actions-col",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Coupons</Box>
                    </Box>
                        </>
                        <Tooltip title="Add new coupon">
                          <IconButton
                            size="small"
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                            style={{
                              width: 32, height: 32,
                              backgroundColor: "#fff",
                              border: "1px solid #5e72e4",
                              color: "#5e72e4",
                            }}
                          >
                            <AddIcon style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip
                          title="Manage Discount Types"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              accessDiscountTypesPage();
                            }}
                          >
                            <span>Discount Types</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                        
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                                      </>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Coupon
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>

                <FormGroup>
                  <FormLabel>Code</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Coupon Code"
                    value={couponCode ?? ""}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Type</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={couponType} onChange={(e) => setCouponType(e.target.value)} IconComponent={KeyboardArrowDown}>
                      {/* <MenuItem value={0}>Fixed</MenuItem> */}
                      <MenuItem value={1}>Percentage</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Value</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Coupon Value"
                    value={couponValue ?? ""}
                    onChange={(e) => setCouponValue(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Min. Order Value</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Min. Order Value"
                    value={minimumOrder ?? ""}
                    onChange={(e) => setMinimumOrder(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Max Discount Value (0 for no maximum)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="0 for no max"
                    value={maxDiscountValue ?? ""}
                    onChange={(e) => setMaxDiscountValue(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Max Utilization (0 for unlimited)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Max No. of Utilization"
                    value={maxUtilization ?? ""}
                    onChange={(e) => setMaxUtilization(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Max Utilization per User (0 for unlimited)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Max No. of Utilization Per User"
                    value={maxUtilizationPerUser ?? ""}
                    onChange={(e) => setMaxUtilizationPerUser(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Start Datetime</FormLabel>
                <DatePicker
                    showTimeSelect
                    selected={startDatetime}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => setStartDatetime(date)}
                    dateFormat="MMMM d, yyyy h:mm aa"
                  />
                  </FormGroup>
                <FormGroup>
                  <FormLabel>End Datetime</FormLabel>
                <DatePicker
                    showTimeSelect
                    selected={endDatetime}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => setEndDatetime(date)}
                    dateFormat="MMMM d, yyyy h:mm aa"
                  />
                  </FormGroup>
                <FormGroup>
                  <FormLabel>Service Applicable</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={serviceApplicable} onChange={(e) => setServiceApplicable(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>Orders</MenuItem>
                      <MenuItem value={1}>Subscription</MenuItem>
                      <MenuItem value={2}>Any</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Override Minimum Order</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={overrideMinimumOrder} onChange={(e) => setOverrideMinimumOrder(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Applicable for Renewal (Subscriptions Only)</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={applicableForRenewal} onChange={(e) => setApplicableForRenewal(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>First Time Only</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isFirstOrderOnly} onChange={(e) => setIsFirstOrderOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Is Subscribers Only</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={subscribedUsersOnly} onChange={(e) => setSubscribedUsersOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Pro Status</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isProOnly} onChange={(e) => setIsProOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>All Users</MenuItem>
                    <MenuItem value={1}>Pro Only</MenuItem>
                    <MenuItem value={-1}>Not Pro</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>Restrict to User IDs (Comma seperated)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="User IDs without leading C"
                    value={restrictedToUserIds ?? ""}
                    onChange={(e) => setRestrictedToUserIds(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Blocks (Comma seperated or empty for no restriction)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Blocks (Comma seperated)"
                    value={restrictedToBlock ?? ""}
                    onChange={(e) => setRestrictedToBlock(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Roads (Comma seperated - Required if buildings/blocks is not empty)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Roads (Comma seperated)"
                    value={restrictedToRoad ?? ""}
                    onChange={(e) => setRestrictedToRoad(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Buildings (Comma seperated - Required if roads/blocks is not empty)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Buildings (Comma seperated)"
                    value={restrictedToBuilding ?? ""}
                    onChange={(e) => setRestrictedToBuilding(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Discount Type</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    {
                      <Select
                        value={discountId}
                        onChange={(e) => {setDiscountId(e.target.value);}}
                        IconComponent={KeyboardArrowDown}
                      >
                        {
                          discountType.map(
                            function (discount, i) {
                              if (discount != null) {
                                return (
                                  <MenuItem value={discount.id}>
                                    {discount.name}
                                  </MenuItem>
                                );
                              }
                            }
                          )
                        }
                      </Select>
                    }
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <FormLabel>External Validation</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={externalService} onChange={(e) => setExternalService(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>None</MenuItem>
                    <MenuItem value={1}>Unipal</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addCouponAction() : updateCouponAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default CouponsTable;
